export default class InitOnAjax {
	static customInitOnAjaxFunctions = [];

	static defaultInitOnAjax(payload) {
		if (payload.insertContentToCopy) {
			let dummyLink = payload.insertContentToCopy;
			let dummy = $('<textarea style="position: absolute">').val(dummyLink.replace(/<br>/g, "\n")).appendTo('body').select();
			dummy.focus();
			document.execCommand('copy');
			dummy.remove();
		}

		if (payload.forceRedirect && payload.redirect) {
			window.location.assign(payload.redirect);
		}

		if (payload.redirectToNewTab) {
			window.open(payload.redirectToNewTab, '_blank').focus();
		}

		if (payload.clearAllFM) {
			toastr.clear();
		}

		if (payload.hideModal) {
			let hideModalElement = document.getElementById(payload.hideModal);

			if (hideModalElement) {
				let hideModal = new bootstrap.Modal(hideModalElement, {});
				if (hideModalElement.style.display === 'block' && !hideModal._isShown) {
					hideModal._isShown = true;
				}

				hideModal.hide();
			}

			let modalBackdrop = document.querySelector('.modal-backdrop');
			if (modalBackdrop) {
				modalBackdrop.remove();
			}
		}

		if (payload.showModal) {
			let showModalElement = document.getElementById(payload.showModal);

			if (showModalElement) {
				let showModal = new bootstrap.Modal(showModalElement, {});
				showModal.show();
			}
		}

		if (payload.flashMessages) {
			Array.prototype.forEach.call(payload.flashMessages, async function (flm, key) {
				showFlashMessage(flm.message, flm.type);
				await sleep(100);
			});
		}

		if (payload.reloadDatatable) {
			Object.entries(payload.reloadDatatable).forEach(([reloadDatatable, datatableNewUrl]) => {
				let datatable = document.getElementById(reloadDatatable);

				if (datatable) {
					$(datatable).DataTable().ajax.url(datatableNewUrl);

					let reloadEvent = new Event("reload");
					datatable.dispatchEvent(reloadEvent);
				}
			});
		}
	}

	static addInitOnAjaxFunction(callback) {
		this.customInitOnAjaxFunctions.push(callback);
	}
}
